module.exports = __webpack_public_path__ + "static/media/flight-seagul-left.821be069.gif";